import classes from "./LoginWithPhoneForm.module.css";
import { useRef } from "react";
import CryptoJS from "crypto-js";

function LoginWithUsernameForm({ setLoginOption }) {
  function aesEncrypt(data) {
    const key = "Xp2s5v8y/A?D(G+KbPeShVmYq3t6w9z$";
    const iv = "";
    const cipher = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse(iv), // parse the IV
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });
    return cipher.toString();
  }

  function checkForSettingData() {
    if (
      phoneInputRef.current.value !== undefined &&
      passInputRef.current.value !== undefined
    ) {
      setLoginOption(phoneInputRef.current.value, passInputRef.current.value);
    }
  }
  const phoneInputRef = useRef();
  const passInputRef = useRef();

  function togglePassVis() {
    var passIn = document.getElementById("password");
    if (passIn.type == "password") passIn.type = "text";
    else passIn.type = "password";
  }

  return (
    <div className={classes.main}>
      <input
        type="phone"
        placeholder="شماره تلفن"
        className={classes.input}
        ref={phoneInputRef}
        required
        id="username"
      />

      <input
        type="password"
        placeholder="کلمه عبور"
        className={classes.input}
        ref={passInputRef}
        required
        id="password"
      />
      <div className={classes.checkbox_container}>
        <input
          type="checkbox"
          className={classes.checkbox}
          onClick={togglePassVis}
        />
        <label htmlFor="checkbox">نمایش کلمه عبور</label>
      </div>
    </div>
  );
}
export default LoginWithUsernameForm;
